import { ThemeIcon } from '@mantine/core';
import { IconCalendarMonth } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { LinkOrigin } from 'src/Services/API/EntityLinks.api';

import styles from './LinkedEventItem.module.scss';
import { Props } from './LinkedEventItem.types';

const formatDates = (start?: string, end?: string | null): string | undefined => {
  if (!start) return undefined;
  const startLabel = dayjs(start).format('DD/MM/YYYY');
  if (!end || dayjs(end).isSame(start, 'day')) return startLabel;
  return `${startLabel} – ${dayjs(end).format('DD/MM/YYYY')}`;
};

const LinkedEventItem = ({ item, onClick }: Props) => {
  const { t } = useTranslation();
  const dates = formatDates(
    item.metadata?.startTime as string | undefined,
    item.metadata?.endTime as string | null | undefined
  );

  return (
    <div className={styles.container} onClick={onClick}>
      <ThemeIcon variant="light" color="blue" size="lg" radius="md">
        <IconCalendarMonth size={18} />
      </ThemeIcon>
      <div className={styles.content}>
        <span className={styles.title}>{item.title}</span>
        {dates && <span className={styles.subtitle}>{dates}</span>}
      </div>
      {item.linkOrigin === LinkOrigin.Business && (
        <span className={styles.origin}>
          {t('entityLinks.automaticLink', 'relié automatiquement')}
        </span>
      )}
    </div>
  );
};

export default LinkedEventItem;
